
"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ThemeProviderProps } from "next-themes/dist/types";
import { useAuth } from "@/components/auth/AuthProvider";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const { user } = useAuth();

  React.useEffect(() => {
    const loadThemePreference = async () => {
      if (!user?.id) return;

      try {
        const { data, error } = await supabase
          .from("user_profiles")
          .select("theme_preference")
          .eq("id", user.id)
          .maybeSingle();

        if (error) throw error;
        
        if (data?.theme_preference) {
          document.documentElement.className = data.theme_preference;
        }
      } catch (error: any) {
        console.error("Error loading theme preference:", error);
        toast.error("Error loading theme preference");
      }
    };

    loadThemePreference();
  }, [user?.id]);

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem={true}
      disableTransitionOnChange={false}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}

export { useTheme } from "next-themes";
